import React from "react";
import { useParams } from "react-router";

import { GetVendor, PutVendor } from "api/rpc/2024-04/facilityAdmin/product/vendor";
import VendorForm from "pages/secure/vendors/VendorForm";
import { VendorWrite } from "pages/secure/vendors/vendorFormState";

export default function VendorsEdit() {
  const { id } = useParams<{ id: string }>();

  return (
    <VendorForm
      mode="edit"
      vendorId={id}
      listPath="/admin/settings/vendors"
      editPath={vendorId => "/admin/settings/vendors/" + String(vendorId)}
      load={vendorId => GetVendor({ id: vendorId }, true)}
      save={(payload: VendorWrite & { id?: number }) => PutVendor({ ...payload, id: Number(payload.id) }, true)}
    />
  );
}
